import { styled } from '@mui/material';

export const SectionMenu = styled('section')({
  width: '100%',
  color: 'whtie',
  marginBottom: '150px',
  '@media (max-width: 520px)': {
    marginBottom: '80px',
  },
});
